'use client';

import { Users } from 'lucide-react';
import { PARTY_SIZE_UNBOUNDED_MAX } from '@cfixe-monorepo/shared';
import { Stepper } from './Stepper';

interface PartySizeSelectorProps {
  partySize: number;
  onChange: (partySize: number) => void;
  /** Plafond proposable — cf. resolvePartySizeMax (miroir de la garde serveur). */
  max: number;
  labels: {
    party_size_label: string;
    party_size_max_hint: string;
    party_size_decrease: string;
    party_size_increase: string;
  };
}

/**
 * Sélecteur « nombre de personnes » (`party_size`) : encadré et surligné, parce que ce nombre
 * MULTIPLIE le prix de la ligne — il pèse autant qu'un choix de durée, pas comme une option
 * discrète. Le plafond est rappelé sous le libellé : sans lui, le client bute sur un « + » inerte
 * sans comprendre pourquoi.
 */
export function PartySizeSelector({ partySize, onChange, max, labels }: PartySizeSelectorProps) {
  /* Plafond rappelé seulement s'il est RÉEL : `PARTY_SIZE_UNBOUNDED_MAX` est la valeur de repli
     d'une prestation sans borne — l'annoncer inventerait une limite que le pro n'a pas posée. */
  const maxHint =
    max < PARTY_SIZE_UNBOUNDED_MAX ? labels.party_size_max_hint.replace('{count}', String(max)) : undefined;
  return (
    <div className="bt-party-size">
      <span className="bt-party-size__head">
        <Users size={16} strokeWidth={2} aria-hidden />
        <span className="bt-party-size__texts">
          <span className="bt-party-size__label">{labels.party_size_label}</span>
          {maxHint && <span className="bt-party-size__hint">{maxHint}</span>}
        </span>
      </span>
      <Stepper
        value={partySize}
        onChange={onChange}
        min={1}
        max={max}
        labels={{ decrease: labels.party_size_decrease, increase: labels.party_size_increase }}
      />
    </div>
  );
}
